<template>
    <section v-if="tasks.length > 0">
      <div>
        <h2>{{ $t('overview.nextVisitTitle') }}</h2>
        <div v-for="(task, i) in tasks" :key="i" class="visit-container">
          <div class="visit">
            <div class="visit__date">
              <span class="visit__day">{{ getDatePart(task, 'DD') }}</span>
              <span class="visit__month">{{ getDatePart(task, 'MMM') }}</span>
            </div>
            <div class="visit__info">
              <span class="visit__time" v-if="!task.hideClock">{{ getDatePart(task, 'HH:mm') }}</span>
              <span class="visit__desc">{{ getVisitDescription(task) }}</span>
            </div>
            <a @click="showModal(i)" class="visit__icon" role="button" tabindex="0" :aria-controls="'visitModal' + i">
              <!-- <AppIcon icon="info"></AppIcon> -->
              <i class="icon-info"></i>
            </a>
          </div>
          <modal :name="'modalVisit' + i" width="90%" :maxWidth="760" :scrollable="true" height="auto" :id="'visitModal' + i">
            <div class="modal">
              <div class="modal__top">
                <h3 class="next__visit__title">{{ $t('overview.nextVisitTitle') }}</h3>
                <a class="modal__close" @click="$modal.hide('modalVisit' + i)" tabindex="0"></a>
              </div>
              <div class="modal__content">
                <div class="visit-details">
                  <div class="visit-details__date">
                    {{ !task.hideClock ? formatDate(task.start_date) : getDatePart(task, 'LL') }}
                  </div>
                </div>
                <!-- <h3>{{ $t('overview.preparationTitle') }}</h3> -->
                <p class="pre-wrap">{{ $t('overview.nextVisitInfoText') }}</p>

                <h3 class="visit__person-title" v-if="task.polygonEmployee">
                  <!-- Project manager -->
                </h3>

                <div class="visit-details" v-if="task.polygonEmployee">
                  <PolygonPerson :polygonPerson="task.polygonEmployee"/>
                </div>

              </div>

            </div>
          </modal>
        </div>
      </div>
    </section>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import repository from '@/core/repository/entity-repository'
import { formatDate } from '@/core/formatting'

export default {
  props: ['numVisitsToShow'],
  data: () => ({
    tasks: [],
    technician: null
  }),
  methods: {
    load() {
      repository.getTasks(this.$route.params.errand_id).done(tasks => {
        const now = moment()
        this.tasks = _.chain(tasks)
          .filter(task => moment(task.start_date).isAfter(now))
          .take(this.numVisitsToShow || 1).value()
      })
    },
    showModal(index) {
      this.$modal.show('modalVisit' + index)
    },
    getDatePart(task, format) {
      return formatDate(task.start_date, format)
    },
    getVisitDescription(task) {
      return _.compact([_.get(task, 'polygonEmployee.name'), _.get(task, 'umbracoTaskType.description')]).join(' - ')
    }
  },
  watch: {
    currentErrand: {
      immediate: true,
      handler() {
        this.load()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.visit__person-title {
  color: color(medium);
  border-bottom: 0.0625rem solid color(medium, 0.5);
  margin-bottom: measure(m);
  text-transform: uppercase;
  padding-bottom: measure(xs)/2;
  @include font-size(s);
}

.next__visit__title {
  margin-top: 0;
}

.visit-container {
  margin-bottom: measure(xs);
  &:last-child {
    margin-bottom: 0;
  }
}

.visit-details__date {
  font-weight: bold;
  @include font-size(l);
}

.visit {
  display: flex;
  padding: measure(m) measure(s);
  @include layout-box;
}

.visit__date {
  display: flex;
  flex-direction: column;
  align-items: center;
  @include font-size(s);
  padding-right: measure(m);
  border-right: 0.0625rem solid color(medium-light);
}

.visit__day {
  @include font-size(xxl);
  line-height: 1;
}

.visit__month {
  text-transform: uppercase;
}

.visit__info {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: center;
  margin-left: measure(m);
  margin-right: measure(m);
}

.visit__desc {
  color: color(medium);
}
  circle, path {
    fill: color(secondary) !important;
    stroke: color(secondary);
  }
.visit__icon {
  align-self: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  font-size: 1.5rem;
  line-height: 1.5rem;
  cursor: pointer;
  // outline: none;
  color: color(primary);

  &:focus {
    @include focus;
  }
}

.visit-details {
  display: flex;
  align-items: center;

  & + & {
    margin-top: measure(xs);
  }
}

.visit-details__icon {
  width: 1.5rem;
  height: 1.5rem;
}

.visit-details__text {
  margin-left: measure(s);
  display: flex;
  flex-direction: column;
}

.visit-details__phone {
  color: inherit;
  text-decoration: none;

  &:focus {
    @include focus;
  }
}

</style>
